export class FieldsetModel {
  label: string;
  hideTitle: boolean;
  collapsible: boolean;
  expanded: boolean;
  hidden: boolean;
  removed: boolean;

  constructor(label: string, hideTitle: boolean, collapsible: boolean, expanded: boolean, removed: boolean) {
    this.label = label;
    this.hideTitle = hideTitle;
    this.collapsible = collapsible;
    this.expanded = expanded;
    this.removed = removed;
    this.hidden = false;
  }

  toggle() {
    if (this.collapsible) this.expanded = !this.expanded;
  }
}